( function ( _s ) {
	_s.fn.splideInit = function () {
		return this.each( el => {
			const _self = _s( el );
			const splideInstance = new Splide( el ).mount();
			const config = JSON.parse( _self.attr( 'data-splide' ) || '{}' );

			if ( config.auto_resize_height ) {
				_s.fn.frSplideResizeHeightOfSlider( splideInstance );
			}

			//Solves weird bug when the carousel is of type loop and you try to adjust the
			//width of the browser: the slides don't resize. This solves it.
			if ( config.refresh_on_resize ) {
				_s( window ).on(
					'resize',
					window.debounce( e => {
						splideInstance.refresh();
					}, 100 )
				);
			}

			if ( config.emit_events ) {
				config.emit_events.forEach( evName => {
					splideInstance.on( evName, ( a, b, c ) => {
						_self.trigger( `fr-splide-${ evName }`, {
							newIndex: a,
							prevIndex: b,
							destIndex: c,
						} );
					} );
				} );
			}
		} );
	};

	_s( document ).ready( () => {
		const _elements = _s( '[splide-init]' );
		if ( _elements.el.length ) {
			window
				.fetchInject( [
					'https://cdn.jsdelivr.net/npm/@splidejs/splide/dist/js/splide.min.js',
				] )
				.then( () => {
					_elements.splideInit();
				} );
		}
	} );
} )( window._s );
